<template>
  <v-btn v-bind="$attrs" :style="buttonStyles" @click="onClick && onClick()">
    <v-icon
      v-show="icon"
      style="color: inherit !important; margin-right: 8px"
      v-bind="$attrs"
      :x-small="iconSize === 'x-small'"
      :small="iconSize === 'small'"
      :x-large="iconSize === 'x-large'"
      :large="iconSize === 'large'"
      >{{ icon }}</v-icon
    >{{ label }}
  </v-btn>
</template>

<script>
export default {
  name: "p-button",

  props: ["icon", "iconSize", "label", "colorful", "onClick"],

  computed: {
    buttonStyles() {
      return {
        "background-color": `${
          this.colorful ? "var(--v-primary-base)" : "var(--v-secondary-base)"
        }`,
        color: `${
          this.colorful ? "var(--v-secondary-base)" : "var(--v-primary-base)"
        } !important`,

        "font-family": "EXO",

        "min-height": "36px !important",
      };
    },
  },
};
</script>

<style scoped>
@import "./styles.css";
</style>
